export default __webpack_public_path__ + "686b914.png";